export default __webpack_public_path__ + "static/image6-8812c4da9815b27618fdabdd3dd04456.gif";